<template>
  <v-container fluid class="alert-container pa-4 pa-md-6">
    <!-- Section Header -->
    <v-card v-if="hasActiveAlerts" flat class="section-header-card mb-6">
      <v-card-text class="d-flex align-center justify-space-between pa-4">
        <div class="d-flex align-center">
          <div class="header-icon-wrap mr-3">
            <v-icon size="22" color="white">mdi-bell-ring</v-icon>
          </div>
          <div>
            <div class="section-title">ภารกิจสถานศึกษา</div>
            <div class="section-subtitle grey--text text--darken-1">
              รายการที่ต้องดำเนินการ {{ totalActiveAlerts }} รายการ
            </div>
          </div>
        </div>
        <v-chip small outlined color="grey" class="hidden-sm-and-down">
          <v-icon x-small left>mdi-update</v-icon>
          อัปเดตล่าสุด: {{ currentTime }}
        </v-chip>
      </v-card-text>
    </v-card>

    <!-- ══════════════════════════════════════ -->
    <!--  กลุ่ม: เร่งด่วน (urgent)                -->
    <!-- ══════════════════════════════════════ -->
    <div v-if="hasUrgentAlerts" class="alert-group mb-6">
      <div class="group-label urgent-label">
        <v-icon x-small color="white" class="mr-1">mdi-alert-circle</v-icon>
        เร่งด่วน
      </div>

      <!-- 1) แจ้งเงื่อนไขการย้าย ครู -->
      <v-card
        v-if="isEnabled(period_college_moves.period_college_enable)"
        id="alert-move_conditions"
        flat
        class="alert-card-item mb-3"
      >
        <div class="card-priority-bar urgent"></div>
        <v-card-text class="pa-0">
          <v-row no-gutters align="center">
            <v-col cols="12" md="8" class="card-content-col">
              <div class="d-flex align-start">
                <div class="card-icon-wrap mr-3" style="background: #dc2626">
                  <v-icon size="20" color="white">mdi-swap-horizontal-bold</v-icon>
                </div>
                <div>
                  <h3 class="card-title">
                    สถานศึกษา แจ้งเงื่อนไขการย้าย ตำแหน่ง ข้าราชการครู
                  </h3>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="card-countdown-col">
              <div class="card-countdown">
                <div class="countdown-label-text">ปิดระบบ</div>
                <div class="countdown-date">
                  {{ dateToThai(period_college_moves.period_college_stop) }}
                </div>
                <div class="countdown-flip-wrap mt-2">
                  <flip-countdown
                    :deadline="period_college_moves.period_college_stop + ' 16:30:00'"
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- 2) แจ้งเงื่อนไขการย้าย ผู้อำนวยการ  ✅ แก้ไข: id ใหม่, title ถูกต้อง -->
      <v-card
        v-if="isEnabled(period_college_moves_director.period_college_enable)"
        id="alert-move_conditions_director"
        flat
        class="alert-card-item mb-3"
      >
        <div class="card-priority-bar urgent"></div>
        <v-card-text class="pa-0">
          <v-row no-gutters align="center">
            <v-col cols="12" md="8" class="card-content-col">
              <div class="d-flex align-start">
                <div class="card-icon-wrap mr-3" style="background: #b91c1c">
                  <v-icon size="20" color="white">mdi-swap-horizontal-bold</v-icon>
                </div>
                <div>
                  <h3 class="card-title">
                    สถานศึกษาให้ความเห็นคณะกรรมการสถานศึกษาการย้าย ตำแหน่ง ผู้อำนวยการสถานศึกษา
                  </h3>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="card-countdown-col">
              <div class="card-countdown">
                <div class="countdown-label-text">ปิดระบบ</div>
                <div class="countdown-date">
                  {{ dateToThai(period_college_moves_director.period_college_stop) }}
                </div>
                <div class="countdown-flip-wrap mt-2">
                  <flip-countdown
                    :deadline="period_college_moves_director.period_college_stop + ' 16:30:00'"
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- 3) เสนอรายชื่อศึกษานิเทศก์ -->
      <v-card
        v-if="isEnabled(period_colleges_committee.period_college_enable)"
        id="alert-committee"
        flat
        class="alert-card-item mb-3"
      >
        <div class="card-priority-bar urgent"></div>
        <v-card-text class="pa-0">
          <v-row no-gutters align="center">
            <v-col cols="12" md="8" class="card-content-col">
              <div class="d-flex align-start">
                <div class="card-icon-wrap mr-3" style="background: #dc2626">
                  <v-icon size="20" color="white">mdi-account-group</v-icon>
                </div>
                <div>
                  <h3 class="card-title">
                    เสนอรายชื่อศึกษานิเทศก์ หรือผู้ทรงคุณวุฒิ
                    ตามหลักเกณฑ์เตรียมความพร้อมและพัฒนาอย่างเข้ม
                    ตำแหน่งครูผู้ช่วย ประจำปี พ.ศ. {{ currentBuddhistYear }}
                  </h3>
                  <p class="card-subtitle mt-1 mb-0">
                    ให้สถานศึกษา เสนอรายชื่อ ศึกษานิเทศก์หรือผู้ทรงคุณวุฒิ
                  </p>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="card-countdown-col">
              <div class="card-countdown">
                <div class="countdown-label-text">ปิดระบบ</div>
                <div class="countdown-date">
                  {{ dateToThai(period_colleges_committee.period_college_stop) }}
                </div>
                <div class="countdown-flip-wrap mt-2">
                  <flip-countdown
                    :deadline="period_colleges_committee.period_college_stop + ' 16:30:00'"
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- 4) สำรวจใบอนุญาตประกอบวิชาชีพเฉพาะ -->
      <v-card
        v-if="isEnabled(period_colleges_teach_license.period_college_enable)"
        id="alert-teach_license"
        flat
        class="alert-card-item mb-3"
      >
        <div class="card-priority-bar urgent"></div>
        <v-card-text class="pa-0">
          <v-row no-gutters align="center">
            <v-col cols="12" md="8" class="card-content-col">
              <div class="d-flex align-start">
                <div class="card-icon-wrap mr-3" style="background: #ea580c">
                  <v-icon size="20" color="white">mdi-certificate</v-icon>
                </div>
                <div>
                  <h3 class="card-title">
                    สำรวจใบอนุญาตประกอบวิชาชีพเฉพาะ
                    (ที่ไม่ใช่ใบประกอบวิชาชีพทางการศึกษา) ของตำแหน่ง ครูผู้ช่วย
                  </h3>
                  <p class="card-subtitle mt-1 mb-0">
                    ให้สถานศึกษา เร่งสำรวจและตรวจสอบ ใบอนุญาตประกอบวิชาชีพเฉพาะ
                  </p>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="card-countdown-col">
              <div class="card-countdown">
                <div class="countdown-label-text">ปิดระบบ</div>
                <div class="countdown-date">
                  {{ dateToThai(period_colleges_teach_license.period_college_stop) }}
                </div>
                <div class="countdown-flip-wrap mt-2">
                  <flip-countdown
                    :deadline="period_colleges_teach_license.period_college_stop + ' 16:30:00'"
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- 5) ประกาศรายชื่อ รองผู้อำนวยการ -->
      <v-card
        v-if="isEnabled(period_sedirector_notice.period_sedirector_enable)"
        id="alert-sedirector_notice"
        flat
        class="alert-card-item mb-3"
      >
        <div class="card-priority-bar urgent"></div>
        <v-card-text class="pa-0">
          <v-row no-gutters align="center">
            <v-col cols="12" md="8" class="card-content-col">
              <div class="d-flex align-start">
                <div class="card-icon-wrap mr-3" style="background: #dc2626">
                  <v-icon size="20" color="white">mdi-account-star</v-icon>
                </div>
                <div>
                  <h3 class="card-title">
                    รายชื่อผู้มีสิทธิเข้ารับการคัดเลือก ตำแหน่ง รองผู้อำนวยการสถานศึกษา
                  </h3>
                  <div class="detail-notes mt-2">
                    <div class="detail-note">
                      <v-icon x-small color="blue" class="mr-1">mdi-information</v-icon>
                      ผู้สมัครและวิทยาลัยสามารถตรวจสอบข้อมูลผ่านระบบ
                    </div>
                    <div class="detail-note warning-note">
                      <v-icon x-small color="orange darken-2" class="mr-1">mdi-alert</v-icon>
                      เฉพาะวิทยาลัยที่ปรากฏผู้สมัคร
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="card-countdown-col">
              <div class="card-countdown">
                <div class="countdown-label-text">ปิดระบบ</div>
                <div class="countdown-date">
                  {{ dateToThai(period_sedirector_notice.period_sedirector_stop) }}
                </div>
                <div class="countdown-flip-wrap mt-2">
                  <flip-countdown
                    :deadline="period_sedirector_notice.period_sedirector_stop + ' 16:30:00'"
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>

    <!-- ══════════════════════════════════════ -->
    <!--  กลุ่ม: สำคัญ (high)                     -->
    <!-- ══════════════════════════════════════ -->
    <div v-if="hasHighAlerts" class="alert-group mb-6">
      <div class="group-label high-label">
        <v-icon x-small color="white" class="mr-1">mdi-star</v-icon>
        สำคัญ
      </div>

      <!-- 6) ประเมิน ภาค ก รองผู้อำนวยการ -->
      <v-card
        v-if="isEnabled(period_college_assistantA.period_college_enable)"
        id="alert-assistant_a"
        flat
        class="alert-card-item mb-3"
      >
        <div class="card-priority-bar high"></div>
        <v-card-text class="pa-0">
          <v-row no-gutters align="center">
            <v-col cols="12" md="8" class="card-content-col">
              <div class="d-flex align-start">
                <div class="card-icon-wrap mr-3" style="background: #f59e0b">
                  <v-icon size="20" color="white">mdi-clipboard-check</v-icon>
                </div>
                <div>
                  <h3 class="card-title">ประเมิน ภาค ก ตำแหน่ง รองผู้อำนวยการ</h3>
                  <div class="detail-notes mt-2">
                    <div class="detail-note warning-note">
                      <v-icon x-small color="orange darken-2" class="mr-1">mdi-alert</v-icon>
                      เฉพาะวิทยาลัยที่ปรากฏผู้สมัคร
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="card-countdown-col">
              <div class="card-countdown">
                <div class="countdown-label-text">ปิดระบบ</div>
                <div class="countdown-date">
                  {{ dateToThai(period_college_assistantA.period_college_stop) }}
                </div>
                <div class="countdown-flip-wrap mt-2">
                  <flip-countdown
                    :deadline="period_college_assistantA.period_college_stop + ' 16:30:00'"
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- 7) รับรายงานตัว รองผู้อำนวยการ -->
      <v-card
        v-if="isEnabled(period_college_redirector.period_college_enable)"
        id="alert-redirector"
        flat
        class="alert-card-item mb-3"
      >
        <div class="card-priority-bar high"></div>
        <v-card-text class="pa-0">
          <v-row no-gutters align="center">
            <v-col cols="12" md="8" class="card-content-col">
              <div class="d-flex align-start">
                <div class="card-icon-wrap mr-3" style="background: #16a34a">
                  <v-icon size="20" color="white">mdi-clipboard-account</v-icon>
                </div>
                <div>
                  <h3 class="card-title">รับรายงานตัว รองผู้อำนวยการ</h3>
                  <div class="detail-notes mt-2">
                    <div class="detail-note warning-note">
                      <v-icon x-small color="orange darken-2" class="mr-1">mdi-alert</v-icon>
                      เฉพาะวิทยาลัยที่ได้รับรองผู้อำนวยการวิทยาลัย
                    </div>
                  </div>
                  <div class="mt-3">
                    <v-btn
                      rounded depressed color="#16a34a" dark
                      class="action-button"
                      @click="viewDatasecDirect()"
                    >
                      <v-icon small left>mdi-magnify</v-icon>
                      ตรวจสอบรายชื่อ
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="card-countdown-col">
              <div class="card-countdown">
                <div class="countdown-label-text">ปิดระบบ</div>
                <div class="countdown-date">
                  {{ dateToThai(period_college_redirector.period_college_stop) }}
                </div>
                <div class="countdown-flip-wrap mt-2">
                  <flip-countdown
                    :deadline="period_college_redirector.period_college_stop + ' 16:30:00'"
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- 8) รับรายงานตัว ย้ายกรณีปกติ -->
      <v-card
        v-if="isEnabled(period_colleges_reportmv.period_college_enable) && period_colleges_reportmv.period_college_type === 'reportmove_teacher'"
        id="alert-reportmv"
        flat
        class="alert-card-item mb-3"
      >
        <div class="card-priority-bar high"></div>
        <v-card-text class="pa-0">
          <v-row no-gutters align="center">
            <v-col cols="12" md="8" class="card-content-col">
              <div class="d-flex align-start">
                <div class="card-icon-wrap mr-3" style="background: #4f46e5">
                  <v-icon size="20" color="white">mdi-account-arrow-right</v-icon>
                </div>
                <div>
                  <h3 class="card-title">รับรายงานตัว ย้ายกรณีปกติ</h3>
                  <div class="detail-notes mt-2">
                    <div class="detail-note warning-note">
                      <v-icon x-small color="orange darken-2" class="mr-1">mdi-alert</v-icon>
                      เฉพาะวิทยาลัยที่ได้รับครูจากการย้ายกรณีปกติตามประกาศ
                    </div>
                  </div>
                  <div class="mt-3">
                    <v-btn
                      rounded depressed color="#4f46e5" dark
                      class="action-button"
                      @click="viewDataMoveTeach()"
                    >
                      <v-icon small left>mdi-magnify</v-icon>
                      ตรวจสอบรายชื่อ
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="card-countdown-col">
              <div class="card-countdown">
                <div class="countdown-label-text">ปิดระบบ</div>
                <div class="countdown-date">
                  {{ dateToThai(period_colleges_reportmv.period_college_stop) }}
                </div>
                <div class="countdown-flip-wrap mt-2">
                  <flip-countdown
                    :deadline="period_colleges_reportmv.period_college_stop + ' 16:30:00'"
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- 9) ครูผู้ช่วย -->
      <v-card
        v-if="isEnabled(periodassteachs.periodAssTeachEnable)"
        id="alert-assteach"
        flat
        class="alert-card-item mb-3"
      >
        <div class="card-priority-bar high"></div>
        <v-card-text class="pa-0">
          <v-row no-gutters align="center">
            <v-col cols="12" md="8" class="card-content-col">
              <div class="d-flex align-start">
                <div class="card-icon-wrap mr-3" style="background: #0891b2">
                  <v-icon size="20" color="white">mdi-school-outline</v-icon>
                </div>
                <div>
                  <h3 class="card-title">ดำเนินการ รับรายงานตัว ครูผู้ช่วย</h3>
                  <div class="mt-3">
                    <v-btn
                      rounded depressed color="#0891b2" dark
                      class="action-button"
                      @click="viewData()"
                    >
                      <v-icon small left>mdi-magnify</v-icon>
                      ตรวจสอบรายชื่อ
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="card-countdown-col">
              <div class="card-countdown">
                <div class="countdown-label-text">ปิดระบบ</div>
                <div class="countdown-date">
                  {{ dateToThai(periodassteachs.periodAssTeachStop) }}
                </div>
                <div class="countdown-flip-wrap mt-2">
                  <flip-countdown
                    :deadline="periodassteachs.periodAssTeachStop + ' 16:30:00'"
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- 10) รายงานเบิกจ่าย พนักงานราชการ -->
      <v-card
        v-if="isEnabled(period_teacher_govem_manpower_report.period_college_enable)"
        id="alert-govem_report"
        flat
        class="alert-card-item mb-3"
      >
        <div class="card-priority-bar high"></div>
        <v-card-text class="pa-0">
          <v-row no-gutters align="center">
            <v-col cols="12" md="8" class="card-content-col">
              <div class="d-flex align-start">
                <div class="card-icon-wrap mr-3" style="background: #f59e0b">
                  <v-icon size="20" color="white">mdi-file-document</v-icon>
                </div>
                <div>
                  <h3 class="card-title">
                    รายงานการบริหารอัตรากำลัง และรายงานการเบิกจ่ายค่าตอบแทน
                    ตำแหน่งพนักงานราชการ
                    <template v-if="period_teacher_govem_manpower_report.period_college_times">
                      ครั้งที่ {{ period_teacher_govem_manpower_report.period_college_times }}
                    </template>
                  </h3>
                  <p class="card-subtitle mt-1 mb-0">
                    ให้วิทยาลัย/สถาบันฯ ดำเนินการรายงานก่อนระบบปิด
                  </p>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="card-countdown-col">
              <div class="card-countdown">
                <div class="countdown-label-text">ปิดระบบ</div>
                <div class="countdown-date">
                  {{ dateToThai(period_teacher_govem_manpower_report.period_college_stop) }}
                </div>
                <div class="countdown-flip-wrap mt-2">
                  <flip-countdown
                    :deadline="period_teacher_govem_manpower_report.period_college_stop + ' 16:30:00'"
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>

    <!-- ══════════════════════════════════════ -->
    <!--  กลุ่ม: ดำเนินการ (normal)               -->
    <!-- ══════════════════════════════════════ -->
    <div v-if="hasNormalAlerts" class="alert-group mb-6">
      <div class="group-label normal-label">
        <v-icon x-small color="white" class="mr-1">mdi-information</v-icon>
        ดำเนินการ
      </div>

      <!-- 11) รายงานอัตรากำลัง -->
      <v-card
        v-if="isEnabled(period_colleges.period_college_enable) && period_colleges.period_college_type === 'update_college'"
        id="alert-manpower"
        flat
        class="alert-card-item mb-3"
      >
        <div class="card-priority-bar normal"></div>
        <v-card-text class="pa-0">
          <v-row no-gutters align="center">
            <v-col cols="12" md="8" class="card-content-col">
              <div class="d-flex align-start">
                <div class="card-icon-wrap mr-3" style="background: #7c3aed">
                  <v-icon size="20" color="white">mdi-chart-bar</v-icon>
                </div>
                <div>
                  <h3 class="card-title">รายงานอัตรากำลัง</h3>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="card-countdown-col">
              <div class="card-countdown">
                <div class="countdown-label-text">ปิดระบบ</div>
                <div class="countdown-date">
                  {{ dateToThai(period_colleges.period_college_stop) }}
                </div>
                <div class="countdown-flip-wrap mt-2">
                  <flip-countdown
                    :deadline="period_colleges.period_college_stop + ' 16:30:00'"
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- 12) แจ้งสาขาวิชา ตำแหน่งว่าง -->
      <v-card
        v-if="isEnabled(period_colleges_manpower.period_college_enable)"
        id="alert-vacancy"
        flat
        class="alert-card-item mb-3"
      >
        <div class="card-priority-bar normal"></div>
        <v-card-text class="pa-0">
          <v-row no-gutters align="center">
            <v-col cols="12" md="8" class="card-content-col">
              <div class="d-flex align-start">
                <div class="card-icon-wrap mr-3" style="background: #0d9488">
                  <v-icon size="20" color="white">mdi-briefcase-outline</v-icon>
                </div>
                <div>
                  <h3 class="card-title">แจ้งสาขาวิชาสำหรับเลขที่ตำแหน่งว่าง</h3>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="card-countdown-col">
              <div class="card-countdown">
                <div class="countdown-label-text">ปิดระบบ</div>
                <div class="countdown-date">
                  {{ dateToThai(period_colleges_manpower.period_college_stop) }}
                </div>
                <div class="countdown-flip-wrap mt-2">
                  <flip-countdown
                    :deadline="period_colleges_manpower.period_college_stop + ' 16:30:00'"
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- 13) สำรวจตำแหน่งว่าง พนักงานราชการ -->
      <v-card
        v-if="isEnabled(period_govem.period_college_enable)"
        id="alert-govem"
        flat
        class="alert-card-item mb-3"
      >
        <div class="card-priority-bar normal"></div>
        <v-card-text class="pa-0">
          <v-row no-gutters align="center">
            <v-col cols="12" md="8" class="card-content-col">
              <div class="d-flex align-start">
                <div class="card-icon-wrap mr-3" style="background: #0d9488">
                  <v-icon size="20" color="white">mdi-briefcase</v-icon>
                </div>
                <div>
                  <h3 class="card-title">สถานศึกษา สถาบันฯ สำรวจตำแหน่งว่าง พนักงานราชการ</h3>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="card-countdown-col">
              <div class="card-countdown">
                <div class="countdown-label-text">ปิดระบบ</div>
                <div class="countdown-date">
                  {{ dateToThai(period_govem.period_college_stop) }}
                </div>
                <div class="countdown-flip-wrap mt-2">
                  <flip-countdown
                    :deadline="period_govem.period_college_stop + ' 23:59:59'"
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>

    <!-- Dialog Components -->
    <Manage_assistant_teacher
      v-bind:OpenDialog_manage_assistant_teacher="OpenDialog_manage_assistant_teachers"
      v-on:toggle-favorite="receiveEmit"
    />
    <Conditons_transfer_success_Vue
      v-bind:OpenDialog_conditons_transfer_success="OpenDialog_conditons_transfer_successs"
      v-on:toggle-favorite="receiveEmit"
    />
    <Sedirector_app
      v-bind:OpenDialog_sedirector_app="OpenDialog_sedirector_apps"
      v-on:toggle-favorite="receiveEmit"
    />
  </v-container>
</template>

<script>
import FlipCountdown from "vue2-flip-countdown";
import Manage_assistant_teacher from "./manage_assistant_teacher.vue";
import Conditons_transfer_success_Vue from "./conditons_transfer_success.vue";
import Sedirector_app from "./sedirector_app.vue";

export default {
  name: "HRvecAlertMissionCollege",

  components: {
    FlipCountdown,
    Manage_assistant_teacher,
    Conditons_transfer_success_Vue,
    Sedirector_app
  },

  data() {
    return {
      ApiKey: "HRvec2021",
      period_colleges: {},
      period_colleges_reportmv: {},
      period_colleges_manpower: {},
      period_teacher_requests: {},
      period_college_moves: {},
      period_college_moves_director: {},       // ✅ ประกาศไว้แล้ว ถูกต้อง
      period_college_moves_attactment: {},
      period_teacher_moves: {},
      perioddiscuss: {},
      periodassteachs: {},
      labels: {
        days: "วัน",
        hours: "ชั่วโมง",
        minutes: "นาที",
        seconds: "วินาที"
      },
      period_college_redirector: {},
      period_college_assistantA: {},
      OpenDialog_manage_assistant_teachers: false,
      OpenDialog_conditons_transfer_successs: false,
      OpenDialog_sedirector_apps: false,
      period_sedirector_notice: {},
      period_govem: {},
      period_colleges_teach_license: {},
      period_colleges_committee: {},
      period_teacher_govem_manpower_report: {},
      currentTime: ""
    };
  },

  mounted() {
    this.updateCurrentTime();
    this._clockTimer = setInterval(() => this.updateCurrentTime(), 60000);

    this.period_collegeAssTeach_licenseQuery();
    this.period_collegeQuery();
    this.period_collegemvQuery();
    this.teacher_requestQuery();
    this.period_college_moveQuery();
    this.period_college_moves_directorQuery();   // ✅ เรียกใน mounted แล้ว ถูกต้อง
    this.period_teacher_moveQuery();
    this.periodDiscussQuery();
    this.periodassteach();
    this.period_collegeSedirectors();
    this.period_college_move_attactment();
    this.period_collegeSedirectors_assistantA();
    this.period_collegeSedirectors_Notice();
    this.period_college_manpowerQuery();
    this.period_govemQuery();
    this.period_colleges_committeeQuery();
    this.fetchPeriodTeacherGovemManpowerReport();
  },

  beforeDestroy() {
    // ✅ เพิ่ม: ล้าง interval เมื่อ component ถูก destroy เพื่อป้องกัน memory leak
    clearInterval(this._clockTimer);
  },

  computed: {
    currentBuddhistYear() {
      return new Date().getFullYear() + 543;
    },

    // ✅ แก้ไข: ใช้ helper isEnabled() แทนการ check string/number ซ้ำๆ
    hasUrgentAlerts() {
      return (
        this.isEnabled(this.period_college_moves.period_college_enable) ||
        this.isEnabled(this.period_college_moves_director.period_college_enable) || // ✅ เพิ่ม
        this.isEnabled(this.period_colleges_committee.period_college_enable) ||
        this.isEnabled(this.period_colleges_teach_license.period_college_enable) ||
        this.isEnabled(this.period_sedirector_notice.period_sedirector_enable)
      );
    },

    hasHighAlerts() {
      return (
        this.isEnabled(this.period_college_assistantA.period_college_enable) ||
        this.isEnabled(this.period_college_redirector.period_college_enable) ||
        (this.isEnabled(this.period_colleges_reportmv.period_college_enable) &&
          this.period_colleges_reportmv.period_college_type === "reportmove_teacher") ||
        this.isEnabled(this.periodassteachs.periodAssTeachEnable) ||
        this.isEnabled(this.period_teacher_govem_manpower_report.period_college_enable)
      );
    },

    hasNormalAlerts() {
      return (
        (this.isEnabled(this.period_colleges.period_college_enable) &&
          this.period_colleges.period_college_type === "update_college") ||
        this.isEnabled(this.period_colleges_manpower.period_college_enable) ||
        this.isEnabled(this.period_govem.period_college_enable)
      );
    },

    hasActiveAlerts() {
      return this.hasUrgentAlerts || this.hasHighAlerts || this.hasNormalAlerts;
    },

    totalActiveAlerts() {
      let count = 0;
      if (this.isEnabled(this.period_college_moves.period_college_enable)) count++;
      if (this.isEnabled(this.period_college_moves_director.period_college_enable)) count++; // ✅ เพิ่ม
      if (this.isEnabled(this.period_colleges_committee.period_college_enable)) count++;
      if (this.isEnabled(this.period_colleges_teach_license.period_college_enable)) count++;
      if (this.isEnabled(this.period_sedirector_notice.period_sedirector_enable)) count++;
      if (this.isEnabled(this.period_college_assistantA.period_college_enable)) count++;
      if (this.isEnabled(this.period_college_redirector.period_college_enable)) count++;
      if (
        this.isEnabled(this.period_colleges_reportmv.period_college_enable) &&
        this.period_colleges_reportmv.period_college_type === "reportmove_teacher"
      ) count++;
      if (this.isEnabled(this.periodassteachs.periodAssTeachEnable)) count++;
      if (this.isEnabled(this.period_teacher_govem_manpower_report.period_college_enable)) count++;
      if (
        this.isEnabled(this.period_colleges.period_college_enable) &&
        this.period_colleges.period_college_type === "update_college"
      ) count++;
      if (this.isEnabled(this.period_colleges_manpower.period_college_enable)) count++;
      if (this.isEnabled(this.period_govem.period_college_enable)) count++;
      return count;
    }
  },

  methods: {
    // ✅ เพิ่ม helper: รองรับทั้ง string "1" และ number 1 ในที่เดียว
    isEnabled(val) {
      return val === "1" || val === 1;
    },

    updateCurrentTime() {
      this.currentTime = new Date().toLocaleTimeString("th-TH", {
        hour: "2-digit",
        minute: "2-digit"
      });
    },

    dateToThai(dateString, format = "full") {
      if (!dateString) return "";
      const date = new Date(dateString);
      const thaiYear = date.getFullYear() + 543;
      const thaiMonths = [
        "มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน",
        "กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"
      ];
      const thaiDays = ["อาทิตย์","จันทร์","อังคาร","พุธ","พฤหัสบดี","ศุกร์","เสาร์"];
      const day = date.getDate();
      const month = date.getMonth();
      const dayOfWeek = date.getDay();

      if (format === "full") {
        return `วัน${thaiDays[dayOfWeek]}ที่ ${day} ${thaiMonths[month]} พ.ศ. ${thaiYear}`;
      }
      if (format === "medium") {
        return `${day} ${thaiMonths[month]} ${thaiYear}`;
      }
      return `${day} ${thaiMonths[month]} พ.ศ. ${thaiYear}`;
    },

    // ─── Dialog Methods ───
    viewDatasecDirect() {
      this.OpenDialog_sedirector_apps = true;
    },
    viewDataMoveTeach() {
      this.OpenDialog_conditons_transfer_successs = true;
    },
    viewData() {
      this.OpenDialog_manage_assistant_teachers = true;
    },
    receiveEmit() {
      this.OpenDialog_manage_assistant_teachers = false;
      this.OpenDialog_conditons_transfer_successs = false;
      this.OpenDialog_sedirector_apps = false;
    },

    // ─── API Methods ───
    period_college_moves_directorQuery() {
      this.$http
        .post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_enable: "1",
          period_college_id: "40103"
        })
        .then(r => { this.period_college_moves_director = r.data || {}; })
        .catch(() => { this.period_college_moves_director = {}; }); // ✅ เพิ่ม catch
    },

    period_colleges_committeeQuery() {
      this.$http
        .post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_enable: "1",
          period_college_id: "60101"
        })
        .then(r => { this.period_colleges_committee = r.data || {}; })
        .catch(() => { this.period_colleges_committee = {}; });
    },

    fetchPeriodTeacherGovemManpowerReport() {
      this.$http
        .post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_enable: "1",
          period_college_id: "80104"
        })
        .then(r => { this.period_teacher_govem_manpower_report = r.data || {}; })
        .catch(() => { this.period_teacher_govem_manpower_report = {}; });
    },

    period_college_manpowerQuery() {
      this.$http
        .post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_enable: "1",
          period_college_id: "701"
        })
        .then(r => { this.period_colleges_manpower = r.data || {}; })
        .catch(() => { this.period_colleges_manpower = {}; });
    },

    period_govemQuery() {
      this.$http
        .post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_id: "801"
        })
        .then(r => { this.period_govem = r.data || {}; })
        .catch(() => { this.period_govem = {}; });
    },

    period_collegeAssTeach_licenseQuery() {
      this.$http
        .post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_enable: "1",
          period_college_id: "601"
        })
        .then(r => { this.period_colleges_teach_license = r.data || {}; })
        .catch(() => { this.period_colleges_teach_license = {}; });
    },

    period_collegeQuery() {
      this.$http
        .post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_enable: "1",
          period_college_id: "501"
        })
        .then(r => { this.period_colleges = r.data || {}; })
        .catch(() => { this.period_colleges = {}; });
    },

    period_collegeSedirectors() {
      this.$http
        .post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_enable: "1",
          period_college_id: "20101"
        })
        .then(r => { this.period_college_redirector = r.data || {}; })
        .catch(() => { this.period_college_redirector = {}; });
    },

    period_collegeSedirectors_Notice() {
      this.$http
        .post("period_sedirector.php", {
          ApiKey: this.ApiKey,
          period_sedirector_enable: "1",
          period_sedirector_id: "202"
        })
        .then(r => { this.period_sedirector_notice = r.data || {}; })
        .catch(() => { this.period_sedirector_notice = {}; });
    },

    period_collegeSedirectors_assistantA() {
      this.$http
        .post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_enable: "1",
          period_college_id: "20100"
        })
        .then(r => { this.period_college_assistantA = r.data || {}; })
        .catch(() => { this.period_college_assistantA = {}; });
    },

    period_collegemvQuery() {
      this.$http
        .post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_enable: "1",
          period_college_id: "30102"
        })
        .then(r => { this.period_colleges_reportmv = r.data || {}; })
        .catch(() => { this.period_colleges_reportmv = {}; });
    },

    teacher_requestQuery() {
      this.$http
        .post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_enable: "1",
          period_college_id: "30101"
        })
        .then(r => { this.period_teacher_requests = r.data || {}; })
        .catch(() => { this.period_teacher_requests = {}; });
    },

    period_college_moveQuery() {
      this.$http
        .post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_enable: "1",
          period_college_id: "401"
        })
        .then(r => { this.period_college_moves = r.data || {}; })
        .catch(() => { this.period_college_moves = {}; });
    },

    period_college_move_attactment() {
      this.$http
        .post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_enable_file: "1",
          period_college_type: "movement_college"
        })
        .then(r => { this.period_college_moves_attactment = r.data || {}; })
        .catch(() => { this.period_college_moves_attactment = {}; });
    },

    period_teacher_moveQuery() {
      this.$http
        .post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_enable: "1",
          period_college_id: "30103"
        })
        .then(r => { this.period_teacher_moves = r.data || {}; })
        .catch(() => { this.period_teacher_moves = {}; });
    },

    periodDiscussQuery() {
      this.$http
        .post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_enable: "1",
          period_college_id: "201"
        })
        .then(r => { this.perioddiscuss = r.data || {}; })
        .catch(() => { this.perioddiscuss = {}; });
    },

    periodassteach() {
      this.$http
        .post("periodassteach.php", {
          ApiKey: this.ApiKey,
          periodAssTeachEnable: "1",
          periodAssTeachID: "102"
        })
        .then(r => { this.periodassteachs = r.data || {}; })
        .catch(() => { this.periodassteachs = {}; });
    }
  }
};
</script>

<style scoped>
.alert-container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-header-card {
  border-radius: 14px !important;
  border: 1px solid #e2e8f0 !important;
  background: #ffffff !important;
}

.header-icon-wrap {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: linear-gradient(135deg, #1e40af, #3b82f6);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.section-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
}

.section-subtitle {
  font-size: 0.82rem;
  margin-top: 2px;
}

.alert-group {
  position: relative;
}

.group-label {
  display: inline-flex;
  align-items: center;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 4px 12px;
  border-radius: 6px;
  color: white;
  margin-bottom: 12px;
}

.group-label.urgent-label { background: #dc2626; }
.group-label.high-label   { background: #d97706; }
.group-label.normal-label { background: #2563eb; }

.alert-card-item {
  border-radius: 14px !important;
  border: 1px solid #e2e8f0 !important;
  position: relative;
  overflow: hidden;
  transition: all 0.25s ease;
  background: #ffffff !important;
  animation: cardSlideIn 0.4s ease-out both;
}

.alert-card-item:hover {
  border-color: #cbd5e1 !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06) !important;
}

.card-priority-bar {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  z-index: 1;
}

.card-priority-bar.urgent { background: #dc2626; }
.card-priority-bar.high   { background: #f59e0b; }
.card-priority-bar.normal { background: #3b82f6; }

.card-content-col {
  padding: 20px 16px 20px 24px;
}

.card-icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}

.card-title {
  font-size: 0.98rem;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.45;
  margin: 0;
}

.card-subtitle {
  font-size: 0.85rem;
  color: #64748b;
  font-weight: 400;
  line-height: 1.4;
}

.detail-note {
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  color: #475569;
  margin-bottom: 4px;
  line-height: 1.4;
}

.warning-note {
  color: #92400e;
  font-weight: 500;
}

.action-button {
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 0.85rem !important;
  letter-spacing: 0 !important;
  padding: 0 20px !important;
  height: 38px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.action-button:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15) !important;
}

.card-countdown-col {
  padding: 16px 20px 16px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-countdown {
  text-align: center;
  padding: 16px 20px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #f1f5f9;
  width: 100%;
}

.countdown-label-text {
  font-size: 0.72rem;
  color: #94a3b8;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 4px;
}

.countdown-date {
  font-size: 0.88rem;
  font-weight: 700;
  color: #dc2626;
}

.countdown-flip-wrap {
  display: flex;
  justify-content: center;
}

@keyframes cardSlideIn {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
}

@keyframes highlightPulse {
  0%   { box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.4); }
  50%  { box-shadow: 0 0 0 8px rgba(37, 99, 235, 0); }
  100% { box-shadow: 0 0 0 0 rgba(37, 99, 235, 0); }
}

.highlight-pulse {
  animation: highlightPulse 0.8s ease-out 3;
  border-color: #3b82f6 !important;
}

@media (max-width: 960px) {
  .card-countdown-col { padding: 0 20px 20px 24px; }
}

@media (max-width: 600px) {
  .card-icon-wrap { width: 36px; height: 36px; }
  .card-title { font-size: 0.9rem; }
}
</style>

<style>
.countdown-flip-wrap .flip-countdown {
  display: flex;
  justify-content: center;
  gap: 6px;
  flex-wrap: wrap;
}

.countdown-flip-wrap .flip-countdown__piece {
  background: #1e293b !important;
  color: white !important;
  border-radius: 8px !important;
  font-weight: 700 !important;
  font-size: 1.1rem !important;
  min-width: 48px !important;
  height: 48px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
}

.countdown-flip-wrap .flip-countdown__slot {
  font-size: 0.68rem !important;
  color: #94a3b8 !important;
  margin-top: 4px !important;
  font-weight: 600 !important;
}
</style>